module.exports = __webpack_public_path__ + "static/media/accordion_down.73a97a33.svg";